<template>
  <div class="solution-summary pb-2">
      <b-card no-body v-if="solicitor_draft_products.length > 0">
          <b-card-header header-bg-variant="primary" header-class="p-2 text-white">
              Sollicitor
          </b-card-header>
          <b-card-body class="px-4 py-2">
            <b-row class="mb-3 pt-2" v-for="(product, index) in solicitor_draft_products" :key="index">
                  <b-col cols="12" md="9">
                      <b-row>
                        <b-col cols="12" class="text-right">
                          <el-button
                            type="text" 
                            @click="previewUpdateProduct(product)"
                          >
                            <i class="fa fa-eye"></i>
                            <small class="ml-2 font-weight-bold">Preview</small>
                          </el-button>
                          </b-col>
                        </b-row>
                      </b-col>
                      <SolicitorPreviewModal 
                        :show_preview.sync="modals.show_preview" 
                        :product="selectedProduct" 
                        />

                          <!-- Legal Product Input -->
                          <b-col cols="12" md="6">
                              <b-form-group label="Legal Product">
                                  <b-form-input v-model="product.product_detail.prod_sol_type" disabled></b-form-input>
                              </b-form-group>
                          </b-col>

                          <!-- Solicitor Dropdown -->
                           
                          <b-col cols="12" md="6">
                            <b-form-group label="Select Solicitor">
                              <el-select v-model="product.product_detail.prod_sol_firm" placeholder="Select Solicitor">
                                <el-option
                                v-for="(solicitor, index) in solicitorList"
                                  :key="index"
                                  :label="solicitor.text"
                                  :value="solicitor.value"
                                ></el-option>
                              </el-select>
                            </b-form-group>
                          </b-col>

                          <b-col cols="12" md="6"  v-if="product.product_detail.prod_sol_type !== 'Vendor SPA'">
                              <b-form-group label="SPA amount">
                                  <b-form-input v-model="product.product_detail.prod_sol_spa_amount"  ></b-form-input>
                              </b-form-group>
                          </b-col>

                          <!-- Vendor Name Input -->
                          <b-col cols="12" md="6">
                              <b-form-group label="Vendor Name">
                                  <b-form-input v-model="product.product_detail.prod_sol_vendor"></b-form-input>
                              </b-form-group>
                          </b-col>

                          <!-- Professional Fees Input -->
                          <b-col cols="12" md="6">
                              <b-form-group label="Professional Fees">
                                  <CurrencyInput v-model="product.product_detail.prod_sol_prof_fees" 
                                  :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                  ></CurrencyInput>
                              </b-form-group>
                          </b-col>

                          <!-- Reimbursement Input -->
                          <b-col cols="12" md="6">
                              <b-form-group label="Reimbursement">
                                  <CurrencyInput v-model="product.product_detail.prod_sol_reimburse"
                                  :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                  ></CurrencyInput>
                              </b-form-group>
                          </b-col>

                          <!-- Disbursement Input -->
                          <b-col cols="12" md="6">
                              <b-form-group label="Disbursement">
                                  <CurrencyInput v-model="product.product_detail.prod_sol_disburse"                                   
                                  :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                  ></CurrencyInput>
                              </b-form-group>
                          </b-col>

                               <!-- Stamp Duty Input (New Field) -->
                                <b-col cols="12" md="6" v-if="product.product_detail.prod_sol_type !== 'Vendor SPA'">
                                  <b-form-group label="Stamp Duty">
                                    <CurrencyInput v-model="product.product_detail.prod_sol_stamp_duty"       
                                    :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                    ></CurrencyInput>
                                  </b-form-group>
                                </b-col>

                          <!-- Subtotal -->
                          <b-col cols="12" md="6">
                              <b-form-group label="Subtotal">
                                  <CurrencyInput v-model="product.product_detail.prod_sol_sub_bef_sst"           
                                   :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                  ></CurrencyInput>
                              </b-form-group>
                          </b-col>

                          <!-- SST 8% -->
                          <b-col cols="12" md="6">
                              <b-form-group label="SST (8%)">
                                  <CurrencyInput v-model="product.product_detail.prod_sol_sst"              
                                   :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                  ></CurrencyInput>
                              </b-form-group>
                          </b-col>

                            <!-- Subtotal -->
                            <b-col cols="12" md="6">
                              <b-form-group label="Subtotal">
                                  <CurrencyInput v-model="product.product_detail.prod_sol_sub_aft_sst"
                                  :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                  ></CurrencyInput>
                              </b-form-group>
                            </b-col>

                          <!-- Discount % on Professional Fees -->
                          <b-col cols="12" md="6">
                              <b-form-group label="Discount % Offer on Professional Fees">
                                  <CurrencyInput v-model="product.product_detail.prod_sol_disc_percent"   
                                  :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                  ></CurrencyInput>
                              </b-form-group>
                          </b-col>

                          <!-- Discount on Professional Fees -->
                          <b-col cols="12" md="6">
                              <b-form-group label="Discount on Professional Fees">
                                  <CurrencyInput v-model="product.product_detail.prod_sol_discount"  
                                   :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                  ></CurrencyInput>
                              </b-form-group>
                          </b-col>

                          <!-- Estimated Grand Total -->
                          <b-col cols="12" md="6">
                              <b-form-group label="Estimated Grand Total">
                                  <!-- <b-form-input :value="calculateGrandTotal(product)" readonly></b-form-input> -->
                                  <CurrencyInput v-model="product.product_detail.prod_sol_estimate_total"              
                                   :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                  ></CurrencyInput>
                              </b-form-group>
                          </b-col>

                  <b-col cols="12" class="mx-auto mt-1 pb-1">
                        <b-row>
                            <b-col cols="12">
                                <div class="d-flex justify-content-end align-items-center">
                                    <div>
                                        <el-button class="bg-success py-2 text-white" 
                                          @click="convertProductToCaseHandler(product)" 
                                          :loading="is_loading.case && is_loading.value === product.prod_id"
                                        ><small class="font-weight-bold text-white">CONVERT TO CASE</small>
                                        </el-button>
                                          <el-button class="bg-danger py-2 text-white" 
                                          @click="removeProductHandler(product)"
                                          :loading="is_loading.case && is_loading.value === product.prod_id"
                                        ><small class="font-weight-bold text-white">REMOVE</small>
                                        </el-button>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
              </b-row>
          </b-card-body>
      </b-card>
      <div class="text-center mt-5" v-else>No draft found.</div>
  </div>
</template>
<script>
import { Image, Button, Select, Option } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import { axios, services, getHeader} from '@/assets/js/httpImports.js'

import { mapState, mapActions } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
import helperFunctionMixin from '@/assets/js/helperFunctionMixin.js'
import SolicitorPreviewModal from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/SolicitorSolution/SolicitorPreviewModal'; 
import debounce from 'lodash.debounce';
import { useLookupStore } from '@/stores/lookupStore'
export default {
  mixins: [notifyFunctionMixin, helperFunctionMixin],
  components: {
      CurrencyInput,
      [Image.name]: Image,
      [Button.name]: Button,
      [Select.name]: Select,
      [Option.name]: Option,
      SolicitorPreviewModal,
  },
  computed:{
      ...mapState(useProductStore, ['solicitor_draft_products']),
  },
  data() {
      return {
          is_loading: {
              case: false,
              value: ''
          },
          solicitorList: [],
          loanTypeOptions: [
            { text: 'Islamic', value: 'islamic' },
            { text: 'Conventional', value: 'conventional' }
          ],
          modals: {
              show_preview: false
          },
          selectedProduct:null,
          feesChargesCache: {},
          calculationCache: {},
      }
  },
  async mounted() {
    this.getSolicitors(); 
  },
  watch: {
    solicitor_draft_products: {
      handler: debounce(function (products) {
        products.forEach(product => {
          this.calculateFields(product.product_detail);
          this.calculate(product.product_detail);
          if (!this.feesChargesCache[product.product_detail.prod_sol_firm_id]) {
          this.getFees(product.product_detail);
        }
      });
      }, 300), 
      immediate: true, 
      deep: true,      
    },
  },
  methods: {
    ...mapActions(useProductStore, ['removeProduct', 'convertProductToCase', 'updateProduct']),
    ...mapActions(useLookupStore, ['getFeesCharges']),
    async calculate(product_detail) {
      const cacheKey = `${product_detail.prod_sol_spa_amount}-${product_detail.prod_sol_loan_margin}`;
      
      if (this.calculationCache[cacheKey]) {
        const responseData = this.calculationCache[cacheKey];
        this.updateProductFees(product_detail, responseData);
        return;  
      }
      
      let url = `${services.temp_mortgage_calc}/calculator/legal-fees`;
      try {
        const purchasePrice = Number(product_detail.prod_sol_spa_amount);
        const loanMargin = Number(product_detail.prod_sol_loan_margin);

        const calculator = {
          calculate_type: "BASIC",
          purchase_price: purchasePrice,
          loan_margin: loanMargin
        };
        let requestData = {
          calculator: calculator
          // client_token: 'clzNYY762WEHTP'
        };

        // const response = await axios.post(url, requestData);
        const response = await axios.post(url, calculator,{ headers: getHeader() })
        const responseData = response.data;

        if (!responseData) {
          console.error("No data returned from API");
          return;
        }

        this.calculationCache[cacheKey] = responseData;
        this.updateProductFees(product_detail, responseData);  // Update product with the calculated fees
      } catch (e) {
        console.error("Error calculating legal fees:", e);
        this.errorFunction(e); 
      }
    },

    updateProductFees(product_detail, responseData) {

      if (product_detail.prod_sol_type.toLowerCase() === "loan agreement") {
        product_detail.prod_sol_prof_fees = responseData.loan_cost.loan_legal_fee;
        product_detail.prod_sol_stamp_duty = responseData.loan_cost.loan_stamp_duty;

      } else {
        product_detail.prod_sol_prof_fees = responseData.spa_cost.spa_legal_fee;
        product_detail.prod_sol_stamp_duty = responseData.spa_cost.stamp_duty;


      }
    },

    async getFees(product_detail) {
      const prodId = product_detail.prod_id;
      
      if (this.feesChargesCache[prodId]) {
        this.updateProductFeesFromCache(product_detail, this.feesChargesCache[prodId]);
        return; 
      }

      try {
        const response = await this.getFeesCharges(product_detail.prod_sol_firm_id);  // Still use firm_id for fetching
        const feesData = response;

        this.feesChargesCache[prodId] = feesData;

        this.updateProductFeesFromCache(product_detail, feesData);
      } catch (error) {
        console.error('Error fetching fees:', error);
        this.errorFunction(error);  
      }
    },

    updateProductFeesFromCache(product_detail, feesData) {
      const reimbursementRow = feesData.find(
        (fee) => fee.product === product_detail.prod_sol_type && fee.fees_type === 'Reimbursement'
      );
      const disbursementRow = feesData.find(
        (fee) => fee.product === product_detail.prod_sol_type && fee.fees_type === 'Disbursement'
      );

      product_detail.prod_sol_reimburse = reimbursementRow ? reimbursementRow.fees_amount : 0;
      product_detail.prod_sol_disburse = disbursementRow ? disbursementRow.fees_amount : 0;
    },
    async getSolicitors() {
      try {
        const res = await axios.get(services.access_control + 'corporate', {
          headers: getHeader(),
          params: {
            corporate_type: 'SOLICITOR'
          }
        });
        // Map response data to use corporate_name and corporate_id
        this.solicitorList = res.data.data.map(solicitor => ({
            text: solicitor.name, // Label for display
            value: solicitor.name   // Unique identifier for selection
        }));
        } catch (e) {
        this.solicitorList = [];
        console.log('Get corporates failed:', e.response?.data?.message || e.message);
      }
    },
 
    calculateFields(detail) {
  const fees = parseFloat(detail.prod_sol_prof_fees) || 0;
  const reimburse = parseFloat(detail.prod_sol_reimburse) || 0;
  const disburse = parseFloat(detail.prod_sol_disburse) || 0;
  const stamp_duty = parseFloat(detail.prod_sol_stamp_duty) || 0;  // Make sure stamp duty is included here

  // 1. Calculate subtotal before SST
  detail.prod_sol_sub_bef_sst = fees + reimburse + disburse + stamp_duty;

  // 2. Calculate SST
  this.calculateSST(detail);

  // 3. Calculate subtotal after SST
  detail.prod_sol_sub_aft_sst = detail.prod_sol_sub_bef_sst + detail.prod_sol_sst;

  // 4. Calculate discount
  detail.prod_sol_discount = (parseFloat(detail.prod_sol_disc_percent) || 0) * fees / 100;

  // 5. Calculate estimated total
  detail.prod_sol_estimate_total = detail.prod_sol_sub_aft_sst - detail.prod_sol_discount;
},
  calculateSST(detail) {
    detail.prod_sol_sst = detail.prod_sol_sub_bef_sst * 0.08;
  },
    resetIsLoading() {
        this.is_loading.case = false;
        this.is_loading.value = '';
    },
    async previewUpdateProduct(product) {
        this.is_loading.case = true;
        this.is_loading.value = product.prod_id;
        try {
            const response = await this.updateProduct(product.prod_id,product); // Capture the response
            this.selectedProduct = product; // Set the selected product
            this.modals.show_preview = true
        } catch (e) {
            this.errorFunction(e);
        } finally {
            this.resetIsLoading();
        }
    },
    async convertProductToCaseHandler(product) {
        this.is_loading.case = true;
        this.is_loading.value = product.prod_id;
        try {
            await this.convertProductToCase(product.prod_id, 'solicitor');
            this.notifySuccess('<b>Case Successfully Created</b>');
            
        } catch (e) {
            this.errorFunction(e);
        } finally {
            this.resetIsLoading();
        }
    },
    async removeProductHandler(product) {
        this.is_loading.case = true;
        this.is_loading.value = product.prod_id;
        try {
            await this.removeProduct(product);
            this.notifySuccess('<b>Draft</b> - Successfully Removed.');
            
        } catch (e) {
            this.errorFunction(e);
        } finally {
            this.resetIsLoading();
        }
    },
   
  }
}
</script>